
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/platformPanels/panels/extensions/platformExtensionsStickyPanel.scss.css.virtualfile';
        module.exports = {"wrapper":"_wrapper_xq3y9_7","root":"_root_xq3y9_13"};